import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import AppFixed from './AppFixed';
import About from './pages/About';

function AppRouterFixed() {
  console.log('🔄 ROUTER-FIXED LOADED - USING APP-FIXED COMPONENT');
  return (
    <Router>
      <Routes>
        <Route path="/" element={<AppFixed />} />
        <Route path="/about" element={<About />} />
      </Routes>
    </Router>
  );
}

export default AppRouterFixed;